export function customerStorySlider() {
    let $customerContainer = $(".customer-story-slider");
    let $customerStory = $customerContainer.find(".customer-story-items");
    let $customerLogo = $customerContainer.find(".customer-logo-slider");

    $customerStory.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".customer-logo-slider",
        mobileFirst: true
    });

    $customerLogo.slick({
        slidesToScroll: 1,
        slidesToShow: 1.2,
        asNavFor: ".customer-story-items",
        dots: false,
        arrows: true,
        infinite: false,
        focusOnSelect: true,
        mobileFirst: true,
        // variableWidth: true,
        responsive: [
            {
                breakpoint: 360,
                settings: {
                    slidesToShow: 2.1,
                }
            },
            {
                breakpoint: 568,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4.8,
                }
            }
        ]
    });

    $customerLogo.on("afterChange", function (event, slick, currentSlide) {
        $(this)[`${slick.$slides.length <= slick.options.slidesToShow + currentSlide ? 'add' : 'remove'}Class`]("last-slider");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customerStorySlider.js